import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Text } from 'foundations-components/components/Text';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { EditIcon } from 'foundations-assets';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Box } from 'foundations-components/transitional/components/Box';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { handleError } from 'commerce-subscription-lib/public/utilities';
import { useCallback, useState } from 'react';
import { useUpdateSubscriptionProperties } from '../hooks/useUpdateSubscriptionProperties';
import { useTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EditableTitle({
  title,
  objectId,
  isEditable
}) {
  const [name, setName] = useState(title);
  const [isEditing, setIsEditing] = useState(false);
  const {
    trackUsage,
    trackInteraction
  } = useTracker(parseInt(objectId, 10));
  const handleOpenChangeEditForm = useCallback(evt => {
    setIsEditing(evt.target.value);
  }, [setIsEditing]);
  const [onSubmit, {
    loading
  }] = useUpdateSubscriptionProperties(objectId, [{
    name: 'hs_name',
    value: name.trim()
  }]);
  const saveChanges = useCallback(() => {
    setIsEditing(false);
    onSubmit().catch(handleError);
    trackUsage('renameSubscriptionSubmitted');
  }, [onSubmit, trackUsage]);
  const cancelChanges = useCallback(() => {
    setName(title);
    setIsEditing(false);
  }, [title, setName, setIsEditing]);
  const startEditing = useCallback(() => {
    setIsEditing(e => !e);
    trackInteraction('renameSubscriptionClicked');
  }, [setIsEditing, trackInteraction]);
  const handleKeyPress = useCallback(({
    key
  }) => {
    if (key === 'Enter') {
      saveChanges();
    }
  }, [saveChanges]);
  const isNameInvalid = name === '' || name.trim() === '' || title === name;
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    paddingInlineEnd: "300",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginInlineEnd: "400",
        marginBlockEnd: "100",
        paddingBlock: "100",
        paddingInline: "400",
        children: name
      })
    }), isEditable && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Popover, {
        open: isEditing,
        onOpenChange: handleOpenChangeEditForm,
        placement: "bottom left",
        content: {
          body: /*#__PURE__*/_jsx(FormControl, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "subscriptions.namePlaceholder"
            }),
            children: /*#__PURE__*/_jsx(TextInput, {
              value: name,
              onKeyPress: handleKeyPress,
              onChange: ({
                target: {
                  value
                }
              }) => {
                if (value !== '' && value.trim() === '') {
                  return;
                }
                setName(value);
              }
            })
          }),
          footer: /*#__PURE__*/_jsxs(ButtonWrapper, {
            children: [/*#__PURE__*/_jsx(Button, {
              disabled: loading || isNameInvalid,
              onClick: saveChanges,
              size: "small",
              use: "tertiary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "subscriptions.save"
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: cancelChanges,
              size: "small",
              use: "tertiary-light",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "subscriptions.cancel"
              })
            })]
          })
        },
        children: /*#__PURE__*/_jsx(IconButton, {
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.edit"
          }),
          placement: "right",
          disabled: loading || isEditing,
          size: "small",
          use: "transparent",
          onClick: startEditing,
          "data-selenium-test": "highlight-editor-icon",
          children: /*#__PURE__*/_jsx(EditIcon, {
            "aria-label": I18n.text('subscriptions.edit')
          })
        })
      })
    })]
  });
}
export default EditableTitle;